import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { guestNavigationItems } from '../config/navigation'
import { useTheme } from '../contexts/ThemeContext'
import Logo from './common/Logo'
import NavigationMenu from './common/NavigationMenu'
import ThemeToggle from './common/ThemeToggle'
import AuthButtons from './common/AuthButtons'
import MobileMenu from './common/MobileMenu'

export default function HeaderGuest() {
  const location = useLocation()
  const pathname = location.pathname
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const { theme } = useTheme()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [pathname])

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${theme === 'dark'
        ? isScrolled
          ? 'bg-black/95 backdrop-blur-md border-b-2 border-gold-500 shadow-lg shadow-gold-500/20'
          : 'bg-black border-b-2 border-gold-500'
        : isScrolled
          ? 'bg-gray-200/95 backdrop-blur-md border-b-2 border-gold-500 shadow-lg shadow-gold-500/20'
          : 'bg-gray-200 border-b-2 border-gold-500'
        }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Logo size={isScrolled ? 'small' : 'normal'} />

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-2 xl:gap-3 flex-1 justify-end max-w-[60%]">
            <NavigationMenu items={guestNavigationItems} variant="desktop" />
            <ThemeToggle variant="desktop" />
            <AuthButtons variant="desktop" />
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden relative w-10 h-10 flex items-center justify-center text-gold-400 hover:text-gold-300 transition-colors duration-300 rounded-lg hover:bg-gold-900/20 active:scale-95"
            aria-label="Toggle menu"
            aria-expanded={isMobileMenuOpen}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </header>
  )
}


